<template>
  <div class="screenshots__slider">
    <AwesomeSlider
      ref="slider"
      :infinite="1"
      @beforeChange="beforeSliderChange"
    >
      <div v-for="(screenshot, index) in screenshots" :key="index">
        <bi-picture
          class="img-responsive"
          :is-legacy="true"
          :thumb-formats="formats"
          :code="screenshot"
          :thumb-sizes="sizes"
        ></bi-picture>
      </div>
    </AwesomeSlider>
    <button class="butn prev" style="" @click="goToPrev">
      <span class="iconmoon-leftarrow"></span>
    </button>
    <button class="butn next" style="" @click="goToNext">
      <span class="iconmoon-rightarrow"></span>
    </button>
    <ul class="list-inline slider-dots">
      <li v-for="(screenshot, index) in screenshots" :key="index">
        <button
          class="butn"
          :class="{ active: activeSlide === index }"
          @click="goTo(index)"
        ></button>
      </li>
    </ul>
  </div>
</template>

<script>
import AwesomeSlider from "../AwesomeSlider";
import BiPicture from "../BiPicture";

export default {
  name: "ScreenshotSlider",
  components: {
    AwesomeSlider,
    BiPicture
  },
  data() {
    return {
      activeSlide: 0,
      screenshots: [
        "screenshots/responsive/screenshot-1",
        "screenshots/responsive/screenshot-2",
        "screenshots/responsive/screenshot-3",
        "screenshots/responsive/screenshot-4",
        "screenshots/responsive/screenshot-5",
        "screenshots/responsive/screenshot-6"
      ],
      formats: ["jpg"],
      sizes: [180, 360, 768, 1024, 1920]
    };
  },
  methods: {
    goToPrev() {
      this.$refs.slider.goToPrev();
    },
    goToNext() {
      this.$refs.slider.goToNext();
    },
    goTo(index) {
      this.$refs.slider.goTo(index);
    },
    beforeSliderChange(current, next) {
      this.activeSlide = next;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/styles/vars";
@import "../../../assets/styles/mixins";

.slider-dots {
  position: absolute;
  bottom: 1em;
  left: 50%;
  transform: translateX(-50%);

  li {
    margin: 0 8px;

    @media (max-width: $screen-xs-min) {
      margin: 0 6px;
    }
  }

  button {
    display: inline-block;
    width: rem(16);
    height: rem(16);
    background-color: rgba(255, 255, 255, 0.45);
    border-radius: 50%;

    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
    }

    &.active {
      background-color: rgba(255, 255, 255, 0.8);
      box-shadow: 0 0 0 em(5) rgba(255, 255, 255, 0.3);
    }

    @media (max-width: $screen-xs-min) {
      width: rem(12);
      height: rem(12);
    }
  }
}
</style>
